import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import Button from "../../../../components/form/Button";

const PublicSuccess = ({ dispatch }) => (
  <div className="publicSuccess">
    <div className="publicSuccess__icon" aria-hidden="true">
      ✓
    </div>
    <h2 className="publicSuccess__title">Vaše podání bylo úspěšně odesláno</h2>
    <p className="publicSuccess__text">
      Děkujeme za vaše podání. Přijali jsme ho a budeme se jím zabývat. <br />O
      výsledku budete informováni na kontaktní adresu, kterou jste uvedli.
    </p>
    <div className="publicSuccess__actions">
      <Button
        style={{ padding: "0 8px 0 8px" }}
        onClick={() => dispatch(push("/"))}
      >
        Zpět na hlavní stránku
      </Button>
    </div>
  </div>
);

export default connect()(PublicSuccess);
